import Button from '@mui/material/Button'
import { SxProps, Theme, useMediaQuery } from '@mui/material'
interface Props {
  handleClick: () => void
  sx?: SxProps<Theme> 
}
const SimpleButton = ({ handleClick, sx }: Props) => {
  const isSmallMobile = useMediaQuery('(max-width: 480px)')
  const isMobile = useMediaQuery('(max-width: 800px)')
  
  return (
    <Button
      sx={{
        minHeight: isSmallMobile ? '40px' : isMobile ? '44px' : '50px',
        fontWeight: '700',
        fontSize: isSmallMobile ? '12px' : isMobile ? '13px' : '14px',
        lineHeight: isSmallMobile ? '16px' : '18px',
        textDecoration: 'underline',
        textTransform: 'capitalize',
        px: isSmallMobile ? '12px' : isMobile ? '16px' : '20px',
        '&:hover': {
          background: 'white',
          textDecoration: 'underline',
        },
        ...sx,
      }}
      onClick={handleClick}
    >
      Annuler
    </Button>
  )
}

export default SimpleButton
